import type {
  ArtboardState,
  EditorAppState,
  IdType,
  MarkupState,
} from 'EditorApp/types'

export const getSelectedArtboard = (state: EditorAppState): ArtboardState => {
  const markup = state.markup.present
  const selected = markup.artboards[state.editor.selected.artboardId]

  return selected ?? getPrimaryArtboard(state)
}

// Resolved from the page rather than from the selection, so an action on a page in some other
// artboard still lands in the right place. Page ids are unique across the whole document.
export const getArtboardForPage = (
  markup: MarkupState,
  pageId: IdType
): ArtboardState | undefined => {
  return Object.values(markup.artboards).find(
    (artboard) => artboard.pages[pageId]
  )
}

// The artboard a document is represented by wherever one size has to stand for the whole thing.
// The head of artboardOrder rather than a stored id, so reordering changes it.
export const getPrimaryArtboard = (state: EditorAppState): ArtboardState => {
  const markup = state.markup.present

  return markup.artboards[markup.artboardOrder[0]]
}

export const selectHasSeveralArtboards = (state: EditorAppState): boolean => {
  return state.markup.present.artboardOrder.length > 1
}

// Across every artboard, not per artboard: the cap bounds how many live Slate editors exist, and
// artboards multiply that rather than each getting their own budget.
export const selectTotalPageCount = (state: EditorAppState): number => {
  return Object.values(state.markup.present.artboards).reduce(
    (total, artboard) => total + artboard.pageOrder.length,
    0
  )
}
